<template>
    <footer class="w-full tablet:w-9/12 mx-auto p-8 text-center">
        <Divider v-if="category == 'full'" class="w-10" />
        <p>Espaço Ventura © 2025 - Todos os direitos reservados</p>
    </footer>
</template>

<script>
import { Divider } from 'primevue';

export default {
    name: 'Footer',
    components: {
        Divider
    },
    props: {
        category: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped></style>